var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: _vm.isMobile } },
    [
      _vm.onlyDetailsView
        ? _c(
            "v-breadcrumbs",
            { staticClass: "pt-0" },
            [
              _vm._t("breadcrumb", function() {
                return [
                  _c(
                    "v-breadcrumbs-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("reset")
                        }
                      }
                    },
                    [_vm._v("\n        Loads\n      ")]
                  ),
                  _vm._v(" "),
                  _vm._.get(_vm.selected, "humanId", false)
                    ? _c("v-breadcrumbs-item", { attrs: { disabled: "" } }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.selected.humanId) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: !_vm.isMobile, column: _vm.isMobile } },
            [
              !_vm.onlyDetailsView
                ? _c(
                    "v-flex",
                    { class: _vm.masterPaneDimension, attrs: { xs12: "" } },
                    [_vm._t("master")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.onlyDetailsView || !_vm.isMobile
                ? _c(
                    "v-flex",
                    {
                      class: [
                        { "pl-2": !_vm.onlyDetailsView },
                        { detailPaneDimension: true }
                      ]
                    },
                    [_vm._t("detail")],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eb6360b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb6360b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MasterDetailPane.vue
// module id = null
// module chunks = 